module Meevo.Plugins.RoyaltyExport {

    import PresetStatus = Meevo.Components.Controls.PresetStatus;

    class ModalRunNowController {
        static $inject = [
            "$mdDialog",
            "startDayOfWeek",
            "meevoDate"
        ];

        public currentDate: Date = new Date();
        public minDate: Date;
        public criteria: any;

        public dateRangeParams = [
            { name: 'LABEL_CUSTOM', status: PresetStatus.Custom },
            { name: 'LABEL_THIS_WEEK', status: PresetStatus.ThisWeek },
            { name: 'LABEL_LAST_WEEK', status: PresetStatus.LastWeek },
            { name: 'LABEL_PREVIOUS_TWO_WEEKS', status: PresetStatus.PreviousTwoWeeks },
            { name: 'LABEL_THIS_MONTH', status: PresetStatus.ThisMonth },
            { name: 'LABEL_LAST_MONTH', status: PresetStatus.LastMonth },
            { name: 'LABEL_YESTERDAY', status: PresetStatus.Yesterday }
        ];

        constructor(
            protected $mdDialog: angular.material.IDialogService,
            public startDayOfWeek: any,
            public meevoDate: Date
        ) {
            this.minDate = this.meevoDate;

            this.criteria = {
                startDate: this.currentDate,
                endDate: this.currentDate
            }
        }

        apply = () => {
            this.$mdDialog.hide({
                criteria: this.criteria
            });
        };

        cancel = () => {
            this.$mdDialog.cancel();
        };
    }

angular.module("meevo.plugins.royaltyExport")
    .controller("meevo.plugins.royaltyExport.ModalRunNowController", ModalRunNowController);
}
